import React from 'react'
import { RadioGroup, Radio } from 'react-radio-group'

import { logError } from '../../../../common/utils/errors'

export default class CreateNewCollectionForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      shouldShowMore: false,
      collectionIsPublic: 'false',
      collectionName: ''
    }
    this.onVisibleInputChange = this.onVisibleInputChange.bind(this)
    this.onAddNewCollection = this.onAddNewCollection.bind(this)
    this.onCollectionNameInputChange = this.onCollectionNameInputChange.bind(
      this
    )
    this.showMore = this.showMore.bind(this)
    this.showLess = this.showLess.bind(this)
  }

  onVisibleInputChange(value) {
    this.setState({
      collectionIsPublic: value
    })
  }

  onCollectionNameInputChange(event) {
    this.setState({
      collectionName: event.target.value
    })
  }

  showMore() {
    this.setState({
      shouldShowMore: true
    })
  }

  showLess(event) {
    if (event) event.preventDefault()
    // clean up modal messages when toggle the form section
    const { dismissModalMessage } = this.props
    dismissModalMessage()
    this.setState({
      shouldShowMore: false,
      collectionName: ''
    })
  }

  onAddNewCollection(event) {
    const { collectionIsPublic, collectionName } = this.state
    const { onCreateNewCollectionFormSubmit, showModalMessage } = this.props
    event.preventDefault()

    if (!collectionName || collectionName === '') {
      showModalMessage({
        type: 'error',
        message: 'You need to name your collection.'
      })
    } else {
      onCreateNewCollectionFormSubmit(collectionName, collectionIsPublic)
        .then(action => {
          if (action && action.type === 'addBookmarkSuccess') {
            this.setState({
              collectionName: '',
              shouldShowMore: false
            })
          }
        })
        .catch(logError)
    }
  }

  render() {
    const { collectionIsPublic, shouldShowMore, collectionName } = this.state
    const { modalMessages } = this.props
    const fromGroupStyle = {
      margin: '16px 0'
    }
    const radioLabelStyle = {
      margin: '0 16px 8px 0'
    }
    const radioInputStyle = {
      marginRight: '8px'
    }
    const whatsThisLinkStyle = {
      fontSize: '11px'
    }
    const cancelButtonStyle = {
      marginLeft: '16px',
      color: '#bababa'
    }
    const messageStyle = {
      margin: '16px 0',
      background: '#c24242',
      color: '#fff',
      padding: '10px',
      display: 'block',
      lineHeight: '10px',
      borderRadius: '2px'
    }

    return (
      <div className="fds-c-modal__section">
        <div className="">
          <h3 className="fds-c-text-heading -size-s">
            Create a new Collection
          </h3>
          <form
            className="fds-c-form -layout-vertical-inline"
            onSubmit={this.onAddNewCollection}
          >
            <div style={fromGroupStyle} className="fds-c-form__group">
              <input
                className="fds-c-form-input -type-string -width-full"
                id="bookmark_form_name"
                name="bookmark_form[name]"
                placeholder="Choose a name that is meaningful and descriptive"
                onClick={this.showMore}
                value={collectionName}
                onChange={this.onCollectionNameInputChange}
                type="text"
              />
            </div>
            {shouldShowMore && (
              <div>
                {modalMessages && (
                  <div style={messageStyle} className="fds-c-form__group">
                    <span className="-size-m -color-mid">
                      {modalMessages.message ||
                        'There was an error creating your collection. Please try again.'}
                    </span>
                  </div>
                )}
                <div style={fromGroupStyle} className="fds-c-form__group">
                  <RadioGroup
                    name="bookmark_form[publically_visible]"
                    selectedValue={collectionIsPublic}
                    onChange={this.onVisibleInputChange}
                  >
                    <label style={radioLabelStyle}>
                      <Radio style={radioInputStyle} value="false" />Keep it
                      private
                    </label>
                    <label style={radioLabelStyle}>
                      <Radio style={radioInputStyle} value="true" />Make it
                      public
                    </label>
                  </RadioGroup>
                </div>
                <div style={fromGroupStyle} className="fds-c-form__group">
                  <a
                    style={whatsThisLinkStyle}
                    className="fds-c-text-link -weight-normal -color-dark -decoration-none"
                    href="https://help.market.envato.com/hc/en-us/articles/202821260"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    What&apos;s this?
                  </a>
                </div>
                <div style={fromGroupStyle} className="fds-c-form__group">
                  <input
                    className="fds-c-button--3d -color-primary"
                    type="submit"
                    value="Add new collection"
                  />
                  <a
                    href="#"
                    style={cancelButtonStyle}
                    className="fds-c-text-link -color-dark -decoration-none fds-u-mt1"
                    onClick={this.showLess}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/modals/collection/createNewCollectionForm.js